import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 拼板，并删除冗余的拼板信息
export function jointBoard(data) {
  return request({
    url: URL.booking.airExport.jointBoard,
    method: 'put',
    data
  })
}
